import { render, staticRenderFns } from "./MaterialBidForm.vue?vue&type=template&id=52f340ec&scoped=true&lang=pug&"
import script from "./MaterialBidForm.vue?vue&type=script&lang=js&"
export * from "./MaterialBidForm.vue?vue&type=script&lang=js&"
import style0 from "./MaterialBidForm.vue?vue&type=style&index=0&id=52f340ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f340ec",
  null
  
)

export default component.exports